import '../../../ProductCard/ProductCard.scss';
import './Wrapper.scss';

import classnames from 'classnames';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { useIsSmallOnly } from '../../../../hooks/mediaQueries';
import { useTheme } from '../../../../hooks/useTheme';
import TRANSLATIONS from '../../../../translations/translations@default.json';
import AOWeRecommendSmile from '../../../ProductCard/AOWeRecommendSmile';
import { Context } from '../../store/store';
import Wrapper from './Wrapper';

const FeatureWrapper = ({ product, index }) => {
	const [state] = useContext(Context);
	const { loaded } = state;

	const theme = useTheme('weRecommend');

	const isSmallOnly = useIsSmallOnly();

	const { CustomCategoriesEnabled } = useSelector(
		({ experimentSwitches }) => experimentSwitches
	);

	const props = isSmallOnly
		? {
				transform: 'scale(1.5)',
				left: '-80px',
		  }
		: {
				transform: 'scale(2)',
				right: '240px',
		  };

	return (
		<li
			id={product.Code}
			className={classnames(
				'relative flex flex-col h-full w-full px-2 xl:px-4 pb-4 my-2 overflow-hidden rounded-lg',
				theme.background,
				{
					'bg-gray-20': !loaded,
					'wrapper--hover': CustomCategoriesEnabled,
				}
			)}
			style={{ WebkitTransform: 'translateZ(0)' }}>
			<div
				className={classnames('text-title-lg py-4', {
					[`${theme.text}`]: loaded,
					'text-gray-20': !loaded,
				})}>
				{TRANSLATIONS.productList.productCard.featuredProductFlag}
			</div>

			{loaded && (
				<AOWeRecommendSmile
					className="absolute top-0"
					style={{ ...props }}
					fill={theme.fill}
				/>
			)}
			<Wrapper {...{ product, index, isFeatured: true }} />
		</li>
	);
};

export default FeatureWrapper;
